import clsx from 'clsx';
import { localeSelector } from '@gandi/translate';
import { Button } from '@gandi/ui';
import { useAppSelector } from '../../../../../../hooks/useAppSelector';
import { pathjoin } from '../../../../../../modules/pathjoin';
var themes = {
  "default": "Svg-default_2kN4X",
  "orange": "Svg-orange_19tb1",
  "red": "Svg-red_xi6MZ",
  "green": "Svg-green_su7pR",
  "purple": "Svg-purple_3fW-G",
  "blue": "Svg-blue_2Ak3M",
  "primary": "Svg-primary_rfFdk"
};
import ProductIcon, { productToTheme } from '../../../../../ProductIcon';
import { selectAppName, selectShopURL } from '../../../../modules/selectors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "ContentBlock-root_2jzys",
  "content": "ContentBlock-content_12ExQ"
};
export function ContentBlock({
  buttonUrl,
  buttonText,
  children,
  productType
}) {
  const appName = useAppSelector(selectAppName);
  const locale = useAppSelector(localeSelector);
  const shopURL = useAppSelector(selectShopURL);
  const finalURL = pathjoin(shopURL, locale, buttonUrl).toString();
  const buttonProps = appName !== 'shop' ? {
    href: finalURL
  } : {
    to: buttonUrl
  };
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(themes[productToTheme[productType]], styles.root),
    children: [/*#__PURE__*/_jsx(ProductIcon, {
      type: productType
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: children
    }), /*#__PURE__*/_jsx(Button, {
      ...buttonProps,
      children: buttonText
    })]
  });
}